<template>
  <WaterfallList
    :dataSource="cocDates"
    :fetchData="handleFetchData"
    :nextVer="nextVer"
    keyField="date"
    class="coope-list"
  >
    <template slot-scope="{ item }">
      <div class="slot">
        <div class="title">
          <div class="time">
            {{ item.monthDate }} <span class="time-year">{{item.year}}</span>
          </div>
        </div>
        <template v-for="(conferenceId, index) in getCocIdsByDate(item.date)">
          <div :key="conferenceId">
            <CocListItem :cocId="conferenceId" :index="index" />
          </div>
        </template>
      </div>
    </template>
  </WaterfallList>
</template>

<script>
import defAvatar from '@/assets/def-avatar.png'
import { WaterfallList } from '@/components/behavior/infinite-list/index'
import { mapActions, mapGetters, mapState } from 'vuex'
import CocListItem from './CocListItem.vue'
import i18n from '@/i18n'

// 历史联系人
export default {
  name: 'CocList',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    WaterfallList,
    CocListItem,
  },
  data() {
    return {
      items: {},
      activeConfId: '',
      defAvatar,
    }
  },
  methods: {
    ...mapActions('coc', ['loadCocs']),
    async handleFetchData() {
      const items = await this.loadCocs({ offset: this.offset })
      return items.length < this.limit
    },
  },
  computed: {
    ...mapGetters('coc', ['getCocIdsByDate', 'offset', 'limit']),
    ...mapState('coc', {
      cocDates: (state) => {
        let currentYear = new Date().getFullYear() + '年'
        return state.cocDates.map((date) => {
          let year = date.substring(0, 5)
          if (year === currentYear) {
            year = ''
          } else {
            currentYear = year
          }
          return {
            get monthDate(){
              const monthDay = date.substring(5)
              const day = monthDay.substring(3)
              const month = monthDay.substring(0, 3)
              return i18n.tc(`special.${month}`) + i18n.tc('special.Th').replace('XX', parseInt(day))
            },
            get year () { return year ? i18n.tc('special.Year').replace('XX', parseInt(year)) : '' },
            date,
            size: 64 + state.cocIdsByDate[date].length * 100,
          }
        })
      },
      nextVer: state => state.reqNextVer
    }),
  },
}
</script>

<style scoped lang="less">
@import url(~@/styles/font.less);
.coope-list {
  height: 100%;
  .slot {
    width: 100%;
    padding-right: 12px;
    .title {
      margin-left: 26px;
      padding-top: 12px;
      padding-right: 20px;
      border-bottom-color: #edeff2;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      .time {
        padding-bottom: 13px;
        font-size: 16px;
        color: #949494;
      }
      .time-year {
        .medium-font(16);
        color: #000;
        float: right;
      }
    }

    .video-slot-ul:hover {
      cursor: pointer;
    }
  }

  ::v-deep {
    .ant-spin-nested-loading,
    .ant-spin-container,
    .vue-recycle-scroller {
      height: 100%;
    }
  }
}
</style>
